<template>
  <div class="surrounding-area-strategy-component">
    <span class="caption">Umkreis</span>
    <span class="label font-weight-medium" v-if="!step.edit_mode">{{settings.radius}}</span>
    <div class="edit-group" v-if="step.edit_mode">
      <v-select
        :items="selectItems"
        v-model="settings.radius"
        label="Intervall"
        outlined
        class="pr-1"
      />
      <ToolTip>
        <template v-slot:title>
          Tooltip Title
        </template>
        <p>
          Dies ist ein Typoblindtext. An ihm kann man sehen, ob alle Buchstaben da sind und wie sie aussehen.
        </p>
        <p>
          Manchmal benutzt man Worte wie Hamburgefonts, Rafgenduks oder Handgloves, um Schriften zu testen.
          Manchmal Sätze, die alle Buchstaben des Alphabets enthalten - man nennt diese Sätze »Pangrams«. Sehr
          bekannt ist dieser: The
        </p>
      </ToolTip>
    </div>
  </div>
</template>

<script>
import ToolTip from "@/components/info/ToolTip";
import {toRef} from "@vue/composition-api";
export default {
  name: "SurroundingAreaStrategyComponent",
  components: {ToolTip},
  props:{
    step: {
      type: Object,
      default: () => new Object()
    }
  },
  setup(props){
    let selectItems = []
    for (let i = 1; i <= 20; i++){
      selectItems.push({text: `${i * 5} km`, value: i * 5 })
    }

    const settings = toRef(props.step, 'settings')

    return {selectItems, settings}
  }
}
</script>

<style scoped lang="scss">
.surrounding-area-strategy-component {
  // Edit grup
  .col-editor-group {
    padding-top: 8px;
    padding-bottom: 8px;
    flex: 0 0 160px;
    max-width: 160px;
  }

  .edit-group {
    position: relative;
    display: flex;
    margin-bottom: $spacer*.75;
    padding-top: 4px;

    .tooltip {
      position: absolute;
      top: -8px;
      right: -24px;
    }
  }

  // Content
  .caption {
    display: block;
    color: map-get($grey, 'darken-1');
    font-size: 14px !important;
    line-height: 17px;
    margin-bottom: $spacer/4;
  }

  .label {
    display: block;
    font-size: 16px;
    line-height: 20px;
    margin-bottom: $spacer/2;
  }
}
</style>
